import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EvaEditorComponent } from './eva-editor.component';

@NgModule({
  declarations: [EvaEditorComponent],
  imports: [CommonModule, FormsModule, TranslateModule],
  exports: [EvaEditorComponent]
})
export class EvaEditorModule {}



// WEBPACK FOOTER //
// ./src/app/modules/eva-editor/eva-editor.module.ts